import { useState, useEffect } from 'react';

const WHATSAPP_URL = 'https://wa.me/5511984095840?text=Ol%C3%A1%2C%20gostaria%20de%20avaliar%20meu%20caso.';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { label: 'Início', id: 'hero' },
    { label: 'Áreas de Atuação', id: 'areas' },
    { label: 'Sobre', id: 'sobre' },
    { label: 'Como Funciona', id: 'como-funciona' },
    { label: 'Contato', id: 'cta' },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? 'backdrop-blur-md' : 'bg-transparent'
        }`}
        style={scrolled ? { backgroundColor: '#0e1410' } : {}}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20 md:h-24 relative">
          {/* Logo — centered on mobile, left on desktop */}
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}
            className="flex items-center cursor-pointer md:static absolute left-1/2 -translate-x-1/2 md:translate-x-0 md:left-auto md:relative"
          >
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/c46a838d2525f8cd633ba5d324174d96.png"
              alt="Bertochi e Lemes Advogados"
              className="h-[72px] md:h-[92px] w-auto object-contain"
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollTo(link.id)}
                className="relative text-white/80 hover:text-brand-gold font-sans text-sm font-medium tracking-wide transition-colors duration-300 group whitespace-nowrap cursor-pointer"
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-brand-gold transition-all duration-300 group-hover:w-full" />
              </button>
            ))}
          </nav>

          {/* Desktop CTA */}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="nofollow noreferrer"
            className="hidden md:flex items-center gap-2 border-2 border-brand-gold text-brand-gold hover:bg-brand-gold hover:text-brand-black font-sans text-sm font-600 px-6 py-2.5 rounded-full transition-all duration-400 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-base" />
            Fale com Especialista
          </a>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden flex items-center justify-center w-10 h-10 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <div className="flex flex-col gap-1.5">
              <span className={`block w-6 h-0.5 bg-brand-gold transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
              <span className={`block w-6 h-0.5 bg-brand-gold transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
              <span className={`block w-6 h-0.5 bg-brand-gold transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
            </div>
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 flex flex-col transition-all duration-500 md:hidden ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        {/* Top solid area */}
        <div className="bg-brand-black pt-24 pb-8 px-8 flex flex-col gap-6">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="text-white font-sans text-xl font-medium text-left hover:text-brand-gold transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="nofollow noreferrer"
            className="mt-4 flex items-center justify-center gap-2 bg-brand-gold text-brand-black font-sans text-base font-600 px-6 py-3 rounded-full whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg" />
            Fale com Especialista
          </a>
        </div>
        {/* Bottom blur area */}
        <div
          className="flex-1 backdrop-blur-sm bg-brand-black/20"
          onClick={() => setMenuOpen(false)}
        />
      </div>
    </>
  );
}
